// The catalogue of games the shell can play, keyed by slug (what share links carry).
// Phase 3 replaces this hand-written list with published modules; until then adding a game
// means adding a line here. Names come from each module's `meta`, so they are not repeated.

export interface GameEntry {
  /** One line for the feed card. */
  blurb: string;
  /** Thunk so bundlers can see the import and split the module into its own chunk. */
  load: () => Promise<unknown>;
}

export const games: Record<string, GameEntry> = {
  blobs: {
    blurb: "Eat the dots, eat anyone smaller, keep away from anyone bigger.",
    load: () => import("./agar/game.js"),
  },
  burrow: {
    blurb: "Dig down for gold, carry what you dug, build your way back up. One world, shared.",
    load: () => import("./burrow/game.js"),
  },
  allotment: {
    blurb: "Till, sow, water, harvest. A ripe crop belongs to whoever gets there first.",
    load: () => import("./allotment/game.js"),
  },
  colossus: {
    blurb: "One enormous boss, endless bullets. Dodge, jump, shoot; beat it and it comes back angrier.",
    load: () => import("./colossus/game.js"),
  },
  alley: {
    blurb: "A brawl down one long street. Goons keep coming; swing, dash, knock them out.",
    load: () => import("./alley/game.js"),
  },
  blastline: {
    blurb: "Every shot takes a chunk out of the scenery. Free the captives in the ruins; the guards shoot back.",
    load: () => import("./blastline/game.js"),
  },
  nightfall: {
    blurb: "Gather sticks by day, build fires, stay in the light. Shades hunt anyone in the dark.",
    load: () => import("./nightfall/game.js"),
  },
  crewed: {
    blurb: "One ship, everybody inside it. Someone steers, someone shoots, someone holds the shield.",
    load: () => import("./crewed/game.js"),
  },
  trapline: {
    blurb: "Race to the flag across a course everyone keeps sabotaging with blocks and spikes.",
    load: () => import("./trapline/game.js"),
  },
  tethered: {
    blurb: "Climb the tower roped to whoever joined before you. If they fall, you fall.",
    load: () => import("./tethered/game.js"),
  },
  shortorder: {
    blurb: "A kitchen that only works if people split the jobs. Grill, chop, assemble, serve.",
    load: () => import("./shortorder/game.js"),
  },
  "hot-potato-tag": {
    blurb: "Thirty-two players, one it. Touch someone to pass it on; the longer you stay free, the higher you climb.",
    load: () => import("./hot-potato-tag/game.js"),
  },
  "commons-acre": {
    blurb: "One shared farm for everyone: till, sow, water and harvest the same plots while chickens wander.",
    load: () => import("./commons-acre/game.js"),
  },
  "skyhop-dash": {
    blurb: "Leap across floating islands to grab the flag first. Every grab sends it flying to a far-off island.",
    load: () => import("./skyhop-dash/game.js"),
  },
};
